import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useToast } from "@/shared/providers/ToastProvider";
import { exportCsv } from "@/shared/lib/exportCsv";

export function usePageActions() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const exportTable = (filename: string, headers: string[], rows: string[][]) => {
    exportCsv(filename, headers, rows);
    showToast(t.actions.exported);
  };

  const printPage = () => {
    window.print();
    showToast(t.actions.printed);
  };

  const notifyDeleted = () => {
    showToast(t.actions.deleted);
  };

  return { exportTable, printPage, notifyDeleted, navigate, showToast };
}
